<script setup>
import { ref, onMounted, defineExpose, getCurrentInstance } from "vue";
import Modal from "../../../../../components/ui-components/modal/Modal.vue";
import mypageUserResumeService from "../../../services/mypage/mypageUserResumeService";
import {usePageLoadingStore} from "../../../../../stores/pageLoading";
import {useUserStore} from "@/pages/user/stores/user";
import {storeToRefs} from "pinia";
import KSASecondaryButton from "@/components/ui-components/button/KSASecondaryButton.vue";
import KSAPrimaryButton from "@/components/ui-components/button/KSAPrimaryButton.vue";
import {useAlertStore} from "@/stores/alertStore";
import {useRoute, useRouter} from "vue-router";
import AlertCustomModal from "@/pages/user/components/modal/jobFair/AlertCustomModal.vue";
import JobFairCorpInfoModal from "@/pages/user/components/modal/jobFair/JobFairCorpInfoModal.vue";
const loadingStore = usePageLoadingStore()
const globals = getCurrentInstance().appContext.config.globalProperties;
const { $pageListBoardNo } = getCurrentInstance().appContext.config.globalProperties;
const { $alert, $confirm } = useAlertStore();

const userStore = useUserStore();
const { user } = storeToRefs(userStore);

const route = useRoute();
const router = useRouter()

const list = ref([]);
const currentPage = ref(1);
const pageSize = ref(10);
const totalPages = ref(1);
const totalCount = ref(0);
const searchOpen = ref(true)

const industryGbOptions = ref(globals.$industryGb || []);
const corpGbOptions = ref(globals.$corpGb || []);
const corpPublicYnOptions = ref(globals.$corpPublicYn || []);

const industryGbListRef = ref(null);
const corpGbListRef = ref(null);
const corpPublicYnListRef = ref(null);
const workAreaCorpRef = ref(null);

const viewSources = ref('');
const corpIds = ref(0);
const alertCustomModal = ref(null);
const modalContent = ref([]);
const corpInfoModal = ref(null);
const baseModal = ref(null);
const resolvePromise = ref(null);

const lectIds = ref(null);
const regDts = ref(null);

const pageSizeGroup = ref([
  { label: "10개씩 보기", value: "10" },
  { label: "30개씩 보기", value: "30" },
  { label: "50개씩 보기", value: "50" },
  { label: "100개씩 보기", value: "100" },
  { label: "500개씩 보기", value: "500" }
]);

const onSelectedCorpArea1Option = (option) => {
  _searchInput.value.workArea1 = option === '시/도 선택' ? '' : option;
};

const onSelectedCorpArea2Option = (option) => {
  _searchInput.value.workArea2 = option === '시/구/군 선택' ? '' : option;
};

// 검색 조건
const getInitialSearchInput = () => ({
  searchCorpName: '',
  searchIndustryGbs: industryGbOptions.value.map(item => item.value),
  searchCorpGbs: corpGbOptions.value.map(item => item.value),
  searchCorpPublicYn: corpPublicYnOptions.value.map(item => item.value),
  searchBizType: '',
  workArea1: '',
  workArea2: '',
});

const _searchInput = ref(getInitialSearchInput());

// 기업 리스트 조회
const retrieveList = () => {
  let userId;
  let regDt;

  if (lectIds.value !== 0 && regDts.value !== 0) {
    userId = user.value.userCd;
    regDt = regDts.value;
  } else {
    userId = 0;
    regDt = "";
  }

  let paramObj = {
    pageNumber: currentPage.value,
    size: pageSize.value,
    userId: userId,
    lectId: lectIds.value,
    regDt: regDt,
    searchCorpName: _searchInput.value.searchCorpName,
    searchIndustryGbs: _searchInput?.value.searchIndustryGbs?.join(',') || "",
    searchCorpGbs: _searchInput?.value.searchCorpGbs?.join(',') || "",
    searchBizType: _searchInput?.value.searchBizType || "",
    searchCorpPublicYn: _searchInput?.value.searchCorpPublicYn?.join(',') || "",
    searchResidences: `${_searchInput?.value.workArea1 || ''}${_searchInput?.value.workArea1 ? ' ' : ''}${_searchInput?.value.workArea2 || ''}`,
  }

  loadingStore.loading = true;
  mypageUserResumeService.retrieveCorporationListPaging(paramObj)
      .then( (res) => {
        loadingStore.loading = false;
        if(res.data.code.toLowerCase() === 'success') {
          const result = res.data.result;
          // console.log('결과', result);
          totalPages.value = result.totalPages;
          totalCount.value = result.totalElements;
          list.value = $pageListBoardNo(result.content, totalCount.value, pageSize.value, currentPage.value);
        }
      }).catch( (error) =>  {
    loadingStore.loading = false;
    console.log(error);
  });
}

// 입사지원하기
const onClickCreateApplicant = async (corpId) => {
  let paramObj;

  if (lectIds.value !== 0 && regDts.value !== 0) {
    paramObj = {
      corpId: corpId,
      userId: user.value.userCd,
      lectId: lectIds.value,
      regDt: regDts.value
    }
  } else {
    paramObj = {
      corpId: corpId,
      userId: user.value.userCd,
    }
  }

  const ok = await $confirm(["해당 기업에 ‘입사지원’을 하시겠습니까?", "입사지원한 이력서는 수정할 수 없습니다."], "입사지원", "아니오");
  if(!ok) {
    return -1;
  } else {
    loadingStore.loading = true;
    mypageUserResumeService.createApplicant(paramObj)
        .then( async (res) => {
          loadingStore.loading = false;
          if(res.data.code.toLowerCase() === 'success') {
            // const result = res.data.result;
            await alertCustomModal.value.show();

            // 마이페이지>상시채용관 현황>입사지원 현황 페이지 이동
            router.push({name: 'UserMatchingJob', query: { tab: 'userResumeApply' }})
          }
        }).catch( (error) =>  {
      loadingStore.loading = false;
      console.log(error);
    });
  }
}

const show = (options = {}) => {
  viewSources.value = options?.viewSource || '';
  corpIds.value = options?.corpId || '';
  currentPage.value = 1;
  clearSearchInput();
  retrieveList();
  baseModal.value.open();
  return new Promise((resolve, _) => {
    resolvePromise.value = resolve;
  });
};

// 기업정보 보기
const onClickViewCorp = async (corpId) => {
  let viewSource = 'promotion'

  corpInfoModal.value.init(false);
  corpInfoModal.value.retrieveCorporation(corpId, 0, viewSource);
  corpInfoModal.value.show();
}

const confirm = () => {
  baseModal.value.close();
  resolvePromise.value(true);
};

const cancel = () => {
  baseModal.value.close();
  resolvePromise.value(false);
};

const init = (lectId, regDt) => {
  lectIds.value = lectId;
  regDts.value = regDt;
}

const clearSearchInput = () => {
  Object.assign(_searchInput.value, getInitialSearchInput());

  if (industryGbListRef.value && industryGbListRef.value.initOptions) {
    industryGbListRef.value.initOptions();
  }
  if (corpGbListRef.value && corpGbListRef.value.initOptions) {
    corpGbListRef.value.initOptions();
  }
  if (corpPublicYnListRef.value && corpPublicYnListRef.value.initOptions) {
    corpPublicYnListRef.value.initOptions();
  }
  if (workAreaCorpRef.value && workAreaCorpRef.value.initSelectedOption) {
    workAreaCorpRef.value.initSelectedOption('시/도 선택', '시/구/군 선택');
  }
};

const onClickSearch = () => {
  currentPage.value = 1;
  retrieveList();
};

const onSelectedPage = (pageNo) => {
  currentPage.value = pageNo;
  retrieveList();
}

// 페이지 사이즈 변경.
const onSelectPageSize = (option) => {
  pageSize.value = option.value;
  currentPage.value = 1;
  retrieveList();
};

defineExpose({
  show,
  init
})
</script>

<template>
  <Modal ref="baseModal">
    <div class="modal-inner xl-size">
      <button class="close" @click="cancel"></button>
      <div class="modal-title">
        <h3>입사지원 기업 선택</h3>
      </div>
      <div class="modal-body">
        <div class="filter-wrap" :class="{'open': searchOpen}">
          <p @click="searchOpen = !searchOpen">검색</p>
          <div class="filter">
            <dl>
              <dt>산업군</dt>
              <dd>
                <KSACheckBoxGroup
                    ref="industryGbListRef"
                    className="mr-md"
                    name="industryGbs"
                    v-model="_searchInput.searchIndustryGbs"
                    :options="industryGbOptions" />
              </dd>
            </dl>
            <dl>
              <dt>기업형태</dt>
              <dd>
                <KSACheckBoxGroup
                    ref="corpGbListRef"
                    className="mr-md"
                    name="corpGbs"
                    v-model="_searchInput.searchCorpGbs"
                    :options="corpGbOptions" />
              </dd>
            </dl>
            <dl>
              <dt>상장여부</dt>
              <dd>
                <KSACheckBoxGroup
                    ref="corpPublicYnListRef"
                    className="mr-md"
                    name="corpPublicYns"
                    v-model="_searchInput.searchCorpPublicYn"
                    :options="corpPublicYnOptions" />
              </dd>
            </dl>
            <dl>
              <dt>업종</dt>
              <dd>
                <KSAInput class="text-box" v-model="_searchInput.searchBizType" placeholder="업종을 입력해주세요." />
              </dd>
            </dl>
            <dl>
              <dt>사업장소재지</dt>
              <dd>
                <KSASelectResidenceArea
                    class="select"
                    ref="workAreaCorpRef"
                    @selectOption1="onSelectedCorpArea1Option"
                    @selectOption2="onSelectedCorpArea2Option"
                />
              </dd>
            </dl>
            <dl>
              <dt>기업명</dt>
              <dd>
                <KSAInput class="text-box" v-model="_searchInput.searchCorpName"  placeholder="기업명을 입력해 주세요." />
              </dd>
            </dl>
            <div class="btn-wrap">
              <KSASecondaryButton class="gray_button" text="초기화" @click="clearSearchInput" />
              <KSAPrimaryButton text="검색" @click="onClickSearch" />
            </div>
          </div>
        </div>
        <div class="list-top">
          <p>전체 <span>{{ $number(totalCount)}}</span>개</p>
          <div>
            <KSASelect :options="pageSizeGroup" class="select" @selectOption="onSelectPageSize" />
          </div>
        </div>
        <div class="table-form">
          <table class="vertical">
            <tr>
              <th class="text-center">NO</th>
              <th class="text-center">기업명</th>
              <th class="text-center">업종</th>
              <th class="text-center">산업군</th>
              <th class="text-center">기업형태</th>
              <th class="text-center">상장여부</th>
              <th class="text-center">입사지원</th>
            </tr>
            <tr v-for="company in list">
              <td class="text-center">{{ company.boardNo }}</td>
              <td class="clickable text-overflow long-overflow" @click="onClickViewCorp(company.corpId)">{{company.corpName}}</td>
              <td class="link text-center text-over">{{ company.bizType }}</td>
              <td class="text-center">{{ $gbNameKR('INDUSTRY_GB', company.industryGb) }}</td>
              <td class="text-center">{{ $gbNameKR('CORP_GB', company.corpGb) }}</td>
              <td class="text-center">{{ company.corpPublicYn === 'Y' ? '상장' : '비상장' }}</td>
              <td class="text-center">
                <span v-if="company.applicantYn === 'Y'" class="gray">지원완료</span>
                <div v-else>
                  <KSATextButton text="입사지원" @click="onClickCreateApplicant(company.corpId)" />
                </div>
              </td>
            </tr>
            <tr v-if="list.length === 0">
              <td class="text-center" colspan="7">
                등록된 기업정보가 없습니다.
              </td>
            </tr>
          </table>
        </div>
        <Paginate
            v-if="list.length > 0"
            v-model="currentPage"
            :page-count="totalPages"
            :click-handler="onSelectedPage"
        />
      </div>
      <div class="modal-footer mt-xs" style="justify-content: center;">
        <KSASecondaryButton class="gray_button" text="취소" @click="cancel" />
      </div>
    </div>
  </Modal>
  <JobFairCorpInfoModal ref="corpInfoModal" :inactive-inner-modal="true" />
  <AlertCustomModal ref="alertCustomModal" :content="modalContent" /> <!-- 커스텀 팝업: 입사지원 완료 -->
</template>

<style lang="scss" scoped>
@import "../../../../../assets/scss/theme";

.clickable {
  cursor: pointer;
  text-decoration: underline;
  color: #3c72ff;
}

.modal-inner {
  width: 598px !important;
}

.list-top {
  p {
    margin-right: 0;
    padding-left: 2px;
    &:first-of-type {
      padding-left: 0;
    }
  }
}

.grid {
  &.half {
    div { width: 312px; }
  }
}

.modal-title p span {
  color: $red_color;
  font-weight: 700;
}

.text-over {
  max-width: 100%;
}

.table-form {
  table-layout: fixed;
  width: 100%;
  overflow: hidden;

  table {
    width: 100%;
    table-layout: fixed;
    .grid {
      span { margin: 0 0 0 10px; }
    }
  }
}
</style>